/*
 * MDV market redirect URL builder.
 *
 * Integration target: the country-selector.js asset currently served from
 * Shopify theme 720. This helper is intentionally side-effect free: callers
 * decide when to assign the returned value to window.location.href.
 */
(function(root, factory) {
	var api = factory();
	if (typeof module === 'object' && module.exports) module.exports = api;
	root.MDVMarketRedirect = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function() {
	'use strict';

	var ALLOWED_MARKET_ORIGINS = [
		'https://www.manieredevoir.com',
		'https://us.manieredevoir.com',
		'https://eu.manieredevoir.com',
		'https://ca.manieredevoir.com',
		'https://au.manieredevoir.com',
		'https://ae.manieredevoir.com',
		'https://at.manieredevoir.com',
		'https://be.manieredevoir.com',
		'https://de.manieredevoir.com',
		'https://dk.manieredevoir.com',
		'https://es.manieredevoir.com',
		'https://fi.manieredevoir.com',
		'https://fr.manieredevoir.com',
		'https://gr.manieredevoir.com',
		'https://it.manieredevoir.com',
		'https://kw.manieredevoir.com',
		'https://lu.manieredevoir.com',
		'https://me.manieredevoir.com',
		'https://nl.manieredevoir.com',
		'https://no.manieredevoir.com',
		'https://pl.manieredevoir.com',
		'https://pt.manieredevoir.com',
		'https://qa.manieredevoir.com',
		'https://ro.manieredevoir.com',
		'https://sa.manieredevoir.com',
		'https://se.manieredevoir.com'
	];

	var allowedOrigins = {};
	ALLOWED_MARKET_ORIGINS.forEach(function(origin) { allowedOrigins[origin] = true; });

	// Origins where Shopify's native ?currency= handling is verified. Glopal-proxied
	// country hosts (fr., de., ae., kw., qa., sa., ...) and ME (legacy client-side
	// Currency.js FX display, which would double-convert) are deliberately excluded;
	// for those destinations the param is simply not added and behaviour is unchanged.
	// Extend only after a live probe of the destination.
	var CURRENCY_PARAM_ORIGINS = {
		'https://www.manieredevoir.com': true,
		'https://us.manieredevoir.com': true,
		'https://eu.manieredevoir.com': true,
		'https://ca.manieredevoir.com': true,
		'https://au.manieredevoir.com': true
	};

	function parseOverlayParams_(value) {
		var raw = String(value || '').trim().replace(/^\?/, '').replace(/&+$/, '');
		return raw ? new URLSearchParams(raw) : new URLSearchParams();
	}

	function buildMarketRedirectUrl(targetOrigin, currentHref, languageValue, currencyValue) {
		var target;
		var current;
		try {
			target = new URL(String(targetOrigin || ''));
			current = new URL(String(currentHref || ''));
		} catch (error) {
			throw new Error('Invalid market redirect URL input.');
		}

		if (target.protocol !== 'https:' || target.username || target.password || !allowedOrigins[target.origin]) {
			throw new Error('Blocked non-allowlisted market destination: ' + target.origin);
		}
		// The current origin is just the page's own URL; restricting it adds no
		// security but guarantees a throw on *.shopifypreview.com and
		// *.myshopify.com, which are exactly the domains used to validate the
		// change before publishing. Only the target destination is validated.
		if (target.pathname !== '/' || target.search || target.hash) {
			throw new Error('Market destination must be an allowlisted origin without a path, query or fragment.');
		}

		target.pathname = current.pathname || '/';
		target.search = current.search;
		// ME's selector reads ?country= on load, uppercases it, and writes a
		// year-long domain-wide selectedCountry cookie. Carrying a stale value
		// across a market hop would override the market the user just chose.
		// This is selector control state, not attribution data.
		target.searchParams.delete('country');
		// Currency is single-hop control state exactly like country: always drop any
		// inherited value so it can never survive a market hop or duplicate.
		target.searchParams.delete('currency');
		target.hash = current.hash;

		// Retain every existing parameter, including UTMs, platform click IDs and
		// non-marketing state. The selector's explicit language choice wins only
		// when it supplies the same parameter name.
		parseOverlayParams_(languageValue).forEach(function(value, key) {
			target.searchParams.set(key, value);
		});

		var normalizedCurrency = String(currencyValue || '').trim().toUpperCase();
		if (/^[A-Z]{3}$/.test(normalizedCurrency) && CURRENCY_PARAM_ORIGINS[target.origin]) {
			target.searchParams.set('currency', normalizedCurrency);
		}

		return target.href;
	}

	return {
		ALLOWED_MARKET_ORIGINS: ALLOWED_MARKET_ORIGINS.slice(),
		buildMarketRedirectUrl: buildMarketRedirectUrl
	};
}));
